/**
 * React Query hook for the logged-in portal identity.
 */

import { useApiQuery } from '@/hooks/react-query/useApiQuery';
import { MeService } from '../services/meService';
import { portalQueryKeys } from './queryKeys';

export function useMe() {
  return useApiQuery(portalQueryKeys.me(), () => MeService.getMe(), {
    showErrorToast: false,
  });
}
